<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>발주 리스트</h2>
      </div>
      <div v-if="device" class="strong-text center">
        <span class="title">총발주 금액:&nbsp;&nbsp;</span><span :class="totalOrderPrice > 0 ? 'plus' : (totalOrderPrice < 0 ? 'minus': 'zero')">{{ Number(totalOrderPrice).toLocaleString() }}</span>원
      </div>
      <div class="table-btn center-right">
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <div v-if="deviceID" class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40" :disabled="downloading">
            <span v-if="!downloading"><img src="/static/img/ico_excel@2x.png" alt=""></span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div v-if="deviceID" @click="resetOrder">
          <button class="btn btn-140">
            <span v-if="!processing" class="download-all">발주 완료</span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div v-if="!deviceID" @click="downloadAllExcel">
          <button class="btn btn-140">
            <span v-if="!downloading" class="download-all">전체 엑셀 다운로드</span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <table>
        <tr class="header">
          <th>트레이 이름</th>
          <th>상품 이름</th>
          <th>최대 개수</th>
          <th>현재 개수</th>
          <th>판매 개수</th>
          <th>폐기 대상</th>
          <!-- <th>만료 개수</th> -->
          <th>발주 날짜</th>
          <th>발주 개수</th>
          <th>공급 단가</th>
          <th>발주 금액</th>
          <th>발주</th>
        </tr>

        <tbody v-if="loading === false && total > 0">
          <tr v-for="item in list" :key="item.trayID">
            <td>
              <div>{{ item.trayName }}</div>
            </td>
            <td>
              <div v-if="item.productID">
                {{ item.productName }}
              </div>
              <div v-else>
                <select v-model="item.newProductID" class="select middle">
                  <option v-for="product in productList" :key="product.productID" :value="product.productID">
                    {{ product.productName }}
                  </option>
                </select>
              </div>
            </td>
            <td>
              <div v-if="item.productID">
                {{ item.capacity }}
              </div>
              <div v-else>
                <input
                  v-model="item.capacity"
                  type="text"
                  class="input small"
                  placeholder="숫자"
                />
              </div>
            </td>
            <td>
              <div>{{ item.currentCount }}</div>
            </td>
            <td>
              <div>{{ item.needCount }}</div>
            </td>
            <td>
              <div>{{ item.expireCount }}</div>
            </td>
            <td>
              <div>{{ item.orderAt }}</div>
            </td>
            <td>
              <div>{{ item.orderCount }}</div>
            </td>
            <td>
              <div>{{ Number(item.supplyPrice).toLocaleString() }}원</div>
            </td>
            <td>
              <div>{{ Number(item.orderPice).toLocaleString() }}원</div>
            </td>
            <td>
              <div class="row">
                <div v-if="!item.productID" class="col">
                  <button class="btn btn-140" @click="addProduct(item, 1)">
                    상품등록
                  </button>
                </div>
                <div v-if="item.productID" class="col">
                  <input
                    v-model="item.count"
                    type="text"
                    class="input small"
                    placeholder="숫자"
                  />
                </div>
                <div v-if="item.productID" class="col">
                  <button class="btn btn-140" @click="addOrder(item)">
                    발주
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-if="!deviceID || !companyID">
            <td colspan="10">{{ '냉장고를 선택해 주세요.' }}</td>
          </tr>
          <tr v-else>
            <td colspan="10">{{ loading ? '조회 중입니다.' : '조회 내역이 없습니다.' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */

import Configuration from '@/js/Configuration';
import js2excel from 'js2excel'; // https://github.com/dwqs/js2excel
import ButtonLoading from '@/components/include/ButtonLoading';
import Device from '../device/Device';

export default {
  components: {
    Device,
    ButtonLoading,
  },
  props: [
    'deviceID',
    'selectEvent',
    'companyID',
  ],
  data: () => ({
    list: [],
    total: 0,
    loading: true,
    downloading: false,
    processing: false,
    device: null,
    productList: [],
    totalOrderPrice: 0,
  }),
  /*
  created() {
    //this.total = 0;
    //this.getList();
  },
  */
  watch: {
    selectEvent() {
      this.total = 0;
      this.getList();
    },
  },
  methods: {
    refreshList() {
      this.total = 0;
      this.getList();
    },
    async getList() {
      if (!this.deviceID) {
        return;
      }

      this.totalOrderPrice = 0;
      this.list = [];
      this.loading = true;

      try {
        const list = [];

        const listURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/${this.deviceID}/tray/product/stock`;
        const resList = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (resList.status !== 200) {
          if (resList.status === 204) {
            this.total = 0;
            this.loading = false;
            return;
          }

          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        this.device = resList.data.device;

        await this.getCompanyData(this.device, 1);
        await this.getDivisionData(this.device);
        await this.getUserData(this.device);
        await this.getProductList(this.device);

        this.device.manufactureDate = this.$moment(this.device.manufactureAt).format('YYYY.MM.DD');
        // this.device.manufactureTime = this.$moment(this.device.manufactureAt).format('hh:mm A');
        this.device.manufactureTime = this.$moment(this.device.manufactureAt).format('HH:mm:ss');
        this.device.setupDate = this.$moment(this.device.setupAt).format('YYYY.MM.DD');
        // this.device.setupTime = this.$moment(this.device.setupAt).format('hh:mm A');
        this.device.setupTime = this.$moment(this.device.setupAt).format('HH:mm:ss');

        if (resList.data.device.trays) {
          this.total = resList.data.device.trays.length;
          let num = this.total;

          for (let i = 0; i < resList.data.device.trays.length; i++) {
            const t = resList.data.device.trays[i];
            t.num = num;
            if (t.products && t.products.length > 0) {
              const p = t.products[0];
              t.productID = p.productID;
              t.productName = p.productName;
              t.capacity = p.capacity;
              t.currentCount = p.currentCount;
              t.needCount = p.capacity - p.currentCount;
              t.stockedDate = p.stockedAt ? this.$moment(p.stockedAt).format('YYYY.MM.DD') : '-';
              // t.stockedTime = p.stockedAt ? this.$moment(p.stockedAt).format('hh:mm A') : '-';
              t.stockedTime = p.stockedAt ? this.$moment(p.stockedAt).format('HH:mm:ss') : '-';
              t.expireCount = p.expireCount;
              t.discardCount = p.discardCount;
              t.discardTotal = p.discardTotal;
              t.orderAt = p.orderAt ? this.$moment(p.orderAt).format('YYYY.MM.DD') : '-';
              t.orderCount = p.orderCount;
              t.supplyPrice = p.supplyPrice;
              t.orderPice = t.orderCount * t.supplyPrice;
              this.totalOrderPrice += t.orderPice;
            } else {
              t.capacity = 0;
              t.currentCount = 0;
              t.needCount = 0;
              t.expireCount = 0;
              t.discardCount = 0;
              t.orderCount = 0;
              t.supplyPrice = 0;
              t.orderPice = 0;
            }
            t.count = 0;
            list.push(t);
            num--;
          }

          this.list = list;
        }
        this.loading = false;
      } catch (e) {
        this.total = 0;
        this.list = [];
        this.loading = false;

        console.error(e);
      }
    },
    async getListForExcel(deviceID) {
      const list = [];
      try {
        const listURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/${deviceID}/tray/product/stock`;
        const resList = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (resList.status !== 200) {
          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        await this.getCompanyData(resList.data.device, 1);
        await this.getCompanyData(resList.data.device, 2);
        await this.getDivisionData(resList.data.device);
        await this.getUserData(resList.data.device);
        await this.getProductList(resList.data.device);

        if (resList.data.device.trays) {
          for (let i = 0; i < resList.data.device.trays.length; i++) {
            const t = resList.data.device.trays[i];

            if (t.products && t.products.length > 0) {
              const p = t.products[0];

              if (p.orderCount > 0) {
                list.push({
                  사업자명: resList.data.device.companyName,
                  사업자번호: resList.data.device.registrationNo,
                  운영자명: resList.data.device.deviceCompanyName,
                  운영자사업자번호: resList.data.device.deviceRegistrationNo,
                  냉장고ID: resList.data.device.deviceAlias,
                  냉장고명: resList.data.device.deviceName,
                  주소: resList.data.device.address,
                  설치장소: resList.data.device.place,
                  전화번호: resList.data.device.mobile,
                  바코드: p.barcode,
                  발주상품명: p.productName,
                  발주상품개수: p.orderCount,
                  발주상품금액: p.orderCount * p.supplyPrice,
                  발주날짜: t.orderAt = p.orderAt ? this.$moment(p.orderAt).format('YYYY.MM.DD') : '-',
                });
              }
            }
          }
        }
      } catch (e) {
        console.error(e);
      }

      return list;
    },
    async getCompanyData(value, n) {
      try {
        let companyID = null;

        if (n === 1) {
          companyID = value.companyID;
        } else {
          companyID = value.deviceCompanyID;
        }

        if (!companyID) {
          return;
        }

        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/company/${companyID}?withDivisions=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          if (n === 1) {
            value.companyName = response.data.company.companyName;
            value.companyAlias = response.data.company.companyAlias;
            value.registrationNo = response.data.company.registrationNo;
          } else {
            value.deviceCompanyName = response.data.company.companyName;
            value.deviceCompanyAlias = response.data.company.companyAlias;
            value.deviceRegistrationNo = response.data.company.registrationNo;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getDivisionData(value) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/division/${value.divisionID}?withUsers=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          value.divisionName = response.data.division.divisionName;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getUserData(value) {
      try {
        const response = await this.$http.get(
          // `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/user/${value.operatorUID}`,
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/user/${value.deviceOperatorUID}`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          value.operatorName = response.data.user.name;
          value.mobile = response.data.user.mobile;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getProductList(value) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CPRODUCT_ADDRESS')}/api/v1/cproduct/product/list?page=1&limit=500&companyID=${value.companyID}`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          this.productList = response.data.products;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async addProduct(item, type) {
      try {
        const tpds = [
          {
            count: 0,
          },
        ];

        let param = null;
        if (type === 1) {
          param = {
            deviceID: item.deviceID,
            trayID: item.trayID,
            productID: item.newProductID,
            capacity: parseInt(item.capacity, 10),
            trayProductDetails: tpds,
          };
        } else {
          param = {
            deviceID: item.deviceID,
            trayID: item.trayID,
            productID: item.productID,
            trayProductDetails: tpds,
          };
        }

        const url = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/tray/${item.trayID}/product`;
        const resList = await this.$http.post(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (resList.status !== 200) {
          if (resList.status === 204) {
            this.getList();
            return;
          }

          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        this.getList();
      } catch (e) {
        alert('처리하지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
    },
    async addOrder(item) {
      try {
        const tpos = {
          orderCount: parseInt(item.count, 10),
        };

        let param = null;
        param = {
          deviceID: item.deviceID,
          trayID: item.trayID,
          productID: item.productID,
          trayProductOrder: tpos,
        };

        const url = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/tray/${item.trayID}/product/order`;
        const resList = await this.$http.put(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (resList.status !== 200) {
          if (resList.status === 204) {
            this.getList();
            return;
          }

          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        this.getList();
      } catch (e) {
        alert('처리하지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
    },
    async downloadExcel() {
      let count = 0;
      try {
        this.downloading = true;
        const list = await this.getListForExcel(this.deviceID);
        if (list.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          this.downloading = false;
          return count;
        }
        js2excel.json2excel({
          data: list,
          name: 'order-excel',
          formateDate: 'yyyy/mm/dd',
        });
        count = list.length;
      } catch (e) {
        console.error(e);
      }

      this.downloading = false;
      return count;
    },
    async downloadAllExcel() {
      let count = 0;

      try {
        this.downloading = true;
        const totalList = [];
        const devices = await this.getDeviceList(this.companyID);

        for (let i = 0; i < devices.length; i++) {
          const list = await this.getListForExcel(devices[i].deviceID);
          Array.prototype.push.apply(totalList, list);
        }

        if (totalList.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          this.downloading = false;
          return count;
        }

        js2excel.json2excel({
          data: totalList,
          name: 'order-all-excel',
          formateDate: 'yyyy/mm/dd',
        });
        count = totalList.length;
      } catch (e) {
        console.error(e);
        count = 0;
      }

      this.downloading = false;

      return count;
    },
    async getDeviceList(companyID) {
      let deviceList = [];

      try {
        let getURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/list?page=1&limit=500`;
        if (companyID) {
          getURL += `&companyID=${companyID}`;
        }
        getURL += '&order=1';

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });

        if (result.status === 200 && result.data.resultCode === '0000') {
          deviceList = result.data.devices;
        }
      } catch (e) {
        deviceList = [];
        console.error(e);
      }

      return deviceList;
    },
    async resetOrder() {
      try {
        if (!confirm('엑셀 다운로드 후 발주내역이 초기화됩니다.\n계속 진행하시겠습니까?')) {
          return;
        }
        this.processing = true;
        // 1.
        const count = await this.downloadExcel();
        if (count === 0) {
          this.processing = false;
          return;
        }

        // 2.
        const url = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/${this.deviceID}/order/reset`;
        const resList = await this.$http.put(url,
          null,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (resList.status !== 200) {
          if (resList.status === 204) {
            this.processing = false;
            this.getList();
            return;
          }

          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }
        this.processing = false;
        this.getList();
      } catch (e) {
        this.processing = false;
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/order/OrderList.vue